import { NotificationDetails } from 'api/hooks/useNotification/use-notification.types';
import { atom } from 'jotai';

export const notificationAtoms = {
  notifications: atom<NotificationDetails[]>([]),
};
